import { ReactNode } from 'react'

type DuplicatePatientConfirmationOptions = {
  title: string
  noAction: string
  yesAction: string
  yesColor: string
  size: 'lg'
  description: () => ReactNode
}

export const getDuplicatePatientConfirmationOptions = (): DuplicatePatientConfirmationOptions => ({
  title: 'Duplicate Patient Warning',
  noAction: 'Use Existing Patient',
  yesAction: 'Create New Patient',
  yesColor: 'danger',
  size: 'lg',
  description: () => (
    <>
      A patient with the same first name, last name, and date of birth already exists in this DME.
      <br />
      <br />
      If this is the same patient, use the existing patient record instead of adding a duplicate
      patient.
      <br />
      <br />
      Do you want to create a new patient anyway?
    </>
  ),
})
